<template>
  <div class="listas-chats">
     <v-card
    class="mx-auto"
    max-width="300"
    tile
  >
    <v-flex xs12 sm12 md12 lg12 pl-2 pr-2>
      <v-text-field class="pr-4" v-model="search" @input="getIncidenciasFiltradas()" :label="$t('buscar')"></v-text-field>
    </v-flex>
    <v-list class="v-list">
      <v-list-item-group v-model="seleccionado" color="primary">
        <v-list-item
          v-for="(item, i) in incidenciasFiltradas"
          :key="i"
          @click="click(item)"
        >
          <v-list-item-content>
            <v-list-item-title v-text="item.referencia + (item.description ? ' - ' + item.description : '')"></v-list-item-title>
            <v-list-item-subtitle class="text--primary claseLocation" v-text="mostrarLocalizacion(item.location)"></v-list-item-subtitle>
            <v-list-item-subtitle v-text="item.nombrePromocion"></v-list-item-subtitle>
            <v-list-item-subtitle v-if="item.fechaUltimoMensaje" v-text="`${$t('chat.ultimoMensaje')} ${item.fechaUltimoMensaje}`"></v-list-item-subtitle>
          </v-list-item-content>
          <!-- <v-list-item-action v-if="item.idActorEmisor && item.idActorEmisor !== getActor"> -->
          <v-list-item-action v-if="item.pendientes && item.pendientes > 0">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon v-bind="attrs" v-on="on" class="badge">
                  {{item.pendientes}}
                </v-btn>
              </template>
              <span>{{ $t('chat.mensajesPendientes') }}</span>
            </v-tooltip>
          </v-list-item-action>
        </v-list-item>
      </v-list-item-group>
    </v-list>
  </v-card>
  </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
export default {
  name: 'lista-chat',
  data () {
    return {
      search: '',
      item: 0,
      incidenciasOrdenadas: [],
      seleccionado: 0,
      incidenciaSinTramitar: false,
      loading: false
    }
  },
  mounted () {
    this.cargarIncidencias(true)
    this.$parent.cambiarCanal(this.incidenciasFiltradas[0])
  },
  computed: {
    ...mapGetters({
      uuid: 'getMyUuid',
      getIncidenciasOrdenadas: 'chat/getIncidenciasOrdenadas',
      tiposSolicitud: 'configuracion/getTiposSolicitud',
      getCanal: 'chat/getCanal'
    }),
    canal () {
      if (this.$store.state.chat.canal) {
        return this.$store.state.chat.canal
      }
      return 'vueChat'
    },
    getActor () {
      return this.$store.state.login.id
    },
    incidenciasFiltradas () {
      var codigosTiposSolicitud = this.tiposSolicitud.map(item => {
        return item.codigoTipoSolicitud
      })
      let incidencias = this.getIncidenciasOrdenadas.filter(item => {
        return codigosTiposSolicitud.indexOf(item.idSolicitud) >= 0
      })

      let listaChat = this

      //+++ Eliminamos las incidencias repetidas
      incidencias = incidencias.reduce((unique, o) => {
          if(!unique.some(obj => obj.id === o.id ) ) {
            unique.push(o);
          }
        return unique;
      },[])

      //ponemos primero las incidencias con chats pendientes
      incidencias.sort(function(a){
        if (a.idActorEmisor !== listaChat.getActor && a.idActorEmisor != null)
            return -1;
        else
          return 1
      });


      if (this.search === '' || this.search.length < 3) return incidencias

      let incidenciasConFiltro = incidencias.filter((item) => {
        var id = item.id || ''
        var referencia = item.referencia || ''
        var description = item.description || ''
        var location = item.location || ''
        var nombrePromocion = item.nombrePromocion || ''
        var fechaUltimoMensaje = item.fechaUltimoMensaje || ''
        var busqueda = this.search.toLowerCase()
        return referencia.toLowerCase().match(busqueda) ||
                id.toLowerCase().match(busqueda) ||
                description.toLowerCase().match(busqueda) ||
                location.toLowerCase().match(busqueda) ||
                nombrePromocion.toLowerCase().match(busqueda) || 
                fechaUltimoMensaje.match(busqueda)
      })
      
      return incidenciasConFiltro
    }
  },
  methods: {
    ...mapActions({
      getIncidencias: 'chat/getIncidencias',
      descargarChat: 'chat/descargarChat',
      marcarMensajesLeidos: 'chat/marcarMensajesLeidos',
    }),
    click: async function (detalleIncidencia) {
      var idIncidenciaCanal = this.canal.toString().slice(-4)

      if(detalleIncidencia.id !== idIncidenciaCanal)
      {
        const loader = this.$loading.show({
          container: this.fullPage ? null : this.$refs.formContainer,
          canCancel: false
        })

        await this.descargarChat(detalleIncidencia.id).then(
          () => {

            // this.marcarMensajesLeidos(this.canal.toString())
            this.$store.commit('chat/setDescargado', true)
            // this.incidenciaSinTramitar = this.comprobarIncidenciaSinTramitar(detalleIncidencia)
            this.$parent.cambiarCanal(detalleIncidencia)

            loader.hide()
          })
          .catch(e => {
            loader.hide()
            return e
          })
        await this.marcarMensajesLeidos()
        this.cargarIncidencias(false)



      }

    },
    comprobarIncidenciaSinTramitar(incidencia) {
      return incidencia.idActorEmisor && incidencia.idActorEmisor !== this.getActor
    },
    recargarIncidencias() {

      // comprobamos que sea una incidencia que esté sin tramitar, si es así, recargamos la lista de incidencias
      if(this.incidenciaSinTramitar) {
        this.cargarIncidencias(true)
        // ponemos la incidencia como tramitada para que no vuelva a recargar
        this.incidenciaSinTramitar = false
      }
    },
    mostrarLocalizacion (localizacion) {
      if (localizacion !== null) {
        return localizacion.replace('<br>', '\n')
      } else {
        return ''
      }
    },
    cargarIncidencias(conLoader) {
      let loader = null
      if(conLoader) {
        loader = this.$loading.show({
          container: this.fullPage ? null : this.$refs.formContainer,
          canCancel: false
        })

      }

      this.getIncidencias()
          .then(() => {
            this.$recompute('incidenciasFiltradas')
            if(conLoader) {
              loader.hide()
            }
          })
          .catch(e => {
            if(conLoader) {
              loader.hide()
            }
            return e
          })
    },
    getIncidenciasFiltradas() {
      return this.incidenciasFiltradas
    }
  }
}
</script>

<style scoped>

.v-list {
  height: calc(100vh - 120px);
  overflow-y: scroll;
}

.lista-chat {
  display: table-row;
  width: 100%;
  height: 26px;
}

textarea {
  width: 98%;
  height: 30px;
  padding: 0 5px;
  margin: 0;
  box-sizing: border-box;
  line-height: 20pt;
  resize: none;
  outline: none;
  font-size: 14px;
  border: solid 1px #AAAAAA;
  border-radius: 3px;
  font-family: Helvetica;
}

.claseLocation {
  white-space: pre-wrap;
}

.badge {
  background-color: #feaeae;
}
</style>
